module.exports = __webpack_public_path__ + "media/images/icons/sw-ct-b0f742a12c48a4a3a6da074e2ec2c2f3.svg";